/**
 * Classified Advertisements
 */

'use strict';

var layout = require('../misc/layout');
var helper = require('../misc/helpers');

// Constructor
var FrontClassifieds = function () {
    if (!$('body').hasClass('cm-classifieds')) {
        return;
    }

    $(document).ready((function() {
        this.uiInitMaterialize();
        this.uiSidebarFixed();
        this.uiSidebarScrollbar();
        this.uiColumnsMinHeight();

        if ($(window).width() < 992) {
            this.uiMobileExpandContent();
        }

        if ($('article#single #images').length > 0) {
            this.imagesSlider();
            this.imageMagnificPopup();
        }

        this.uiHoverCurrentViewed();
        this.uiSidebarHoverItem();
        this.searchForm();
        this.populateSearchFormFromCookies();
        this.reinitializeSearch();
        this.selectPostFromSidebar();
    }).bind(this));
};

FrontClassifieds.prototype = {
    lockAjaxGetResults: false,
    lockAjaxGetPost: false,

    uiInitMaterialize: function() {
        layout.disableMaterializeDropdownOnMobile($('aside#sidebar .results-top'));
    },

    /**
     * For mobile and tablet devises, expand or close the sidebar
     * to reveal the classified ad content.
     */
    uiMobileExpandContent: function() {
        var self = this;
        var sidebarWidth = $('aside#sidebar').width();

        $('aside#sidebar .button-expand').on('click', function() {
            if ($('aside#sidebar').hasClass('closed')) {
                // The sidebar is closed, display it
                $('aside#sidebar').stop().animate({
                    'margin-left': '0px',
                }, 500, function() {
                    $('aside#sidebar .button-expand i').text('first_page');
                    $('aside#sidebar').removeClass('closed');
                    $('article#single').hide();
                    $(window).trigger('resize');
                });
            } else {
                // The sidebar is opened, close it
                $('aside#sidebar').stop().animate({
                    'margin-left': '-' + sidebarWidth + 'px',
                }, 500, function() {
                    $('aside#sidebar .button-expand i').text('last_page');
                    $('aside#sidebar').addClass('closed');
                    $('article#single').show();
                    $(window).trigger('resize');
                });
            }
        });
    },

    /**
     * Set the position of the sidebar as fixed when the user scroll.
     */
    uiSidebarFixed: function() {
        var sidebar = $('aside#sidebar');
        var headerNav = $('#site-header nav');

        var setFixedPosition = function() {
            var scroll = $(window).scrollTop();
            var height = headerNav.height();

            if (scroll == 0) {
                height = 100 + $('#site-header .top').height();
            }

            if ($(window).width() < 992) {
                height = 85;
            }

            sidebar.css('top', height + 'px');
        };

        $(window).scroll(function(){
            setFixedPosition();
        });

        setFixedPosition();
    },

    /**
     * Display scrollbar in the sidebar and the content area.
     */
    uiSidebarScrollbar: function() {
        var self = this;

        $('aside#sidebar .inner').mCustomScrollbar({
            axis: 'y',
            scrollInertia: 200,
            theme: 'comedien',
            mouseWheel: {
                preventDefault: true
            },
            callbacks: {
                onTotalScroll: function() {
                    self.loadMorePosts(this);
                }
            },
            advanced: {
                updateOnContentResize: false, // We will manually call mCustomScrollbar("update") instead (see below)...
            }
        });

        // "Bug fix": dropdown materialize + overflow hidden of the scrollbar container
        var parentHeight = $('aside#sidebar .inner').height();
        $('aside#sidebar .inner #mCSB_1_container').css('min-height', parentHeight + 'px');

        $(window).on('resize', function() {
            $('aside#sidebar .inner').mCustomScrollbar("update");

            var parentHeight = $('#results').height();
            $('aside#sidebar .inner #mCSB_1_container').css('min-height', parentHeight + 'px');
        });

        // Bug fix: mCustomScrollbar with Materializ dropdown
        // Temporally disable the mCustomScrollbar scrollbar when the dropdown is open,
        // then reactivate it.

        $('#results-searchform .input-field .select-wrapper ul').hover (
            function () {
                $('aside#sidebar .inner').mCustomScrollbar('disable');
            },
            function () {
                $('aside#sidebar .inner').mCustomScrollbar('update');
            }
        );
    },

    /**
     * Equal columns heights for the sidebar (left) and the content (right).
     */
    uiColumnsMinHeight: function() {
        var computeMinHeight = function() {
            var height = $(window).height() - $('main#content').offset().top;
            if (height > 0) {
                height = height + 0; // hide the footer horizontal nav menu
                if ($(window).width() > 992) {
                    $('main#content aside#sidebar').css('min-height', height + 'px');
                    $('main#content article#single').css('min-height', height + 'px');
                } else {
                    $('main#content aside#sidebar').css('height', height + 'px');
                    $('main#content article#single').css('height', height + 'px');
                }
            }
        };

        $(window).on('resize', function() {
            computeMinHeight();
        });

        computeMinHeight();

        $('footer#site-footer').css('margin-top', '-100px');
    },

    /**
     * Add a delayed hover effect on the sidebar's items.
     */
    uiSidebarHoverItem: function() {
        var timer;

        $('aside#sidebar .items .item').mouseenter(function() {
            var that = this;
            timer = setTimeout(function(){
                $('aside#sidebar .items .item:not(.current)').removeClass('hover');
                $(that).addClass('hover');
            }, 250);
        }).mouseleave(function() {
            clearTimeout(timer);
            $('aside#sidebar .items .item:not(.current)').removeClass('hover');
        });
    },

    /**
     * On page load, hover the current viewed post (normally the last modified of the category) on the sidebar's items.
     */
    uiHoverCurrentViewed: function() {
        var id = this.getIdCurrentViewed();

        $('aside#sidebar .items .item').removeClass('hover').removeClass('current');
        $('aside#sidebar .items .item[data-id="' + id + '"]').addClass('hover').addClass('current');
    },

    /**
     * Get the ID of the current viewed classified ad.
     *
     * @returns {Number}
     */
    getIdCurrentViewed: function() {
        return parseInt($('article#single').data('id'));
    },

    /**
     * Initialize the images slider.
     */
    imagesSlider: function() {
        $('article#single #images').slick({
            adaptiveHeight: true,
            autoplay: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            asNavFor: 'article#single #images-thumbnails',
        });

        $('article#single #images-thumbnails').slick({
            autoplay: false,
            slidesToShow: 6,
            slidesToScroll: 1,
            focusOnSelect: true,
            dots: true,
            arrows: false,
            asNavFor: 'article#single #images',
        });
    },

    /**
     * Initialize the image popup with Magnific Popup.
     */
    imageMagnificPopup: function() {
        $('article#single #images').magnificPopup({
            delegate: '.image a',
            type: 'image',
            closeOnContentClick: false,
            closeBtnInside: false,
            mainClass: 'mfp-with-zoom mfp-img-mobile',
            image: {
                titleSrc: function (item) {
                    return '';
                }
            },
            gallery: {
                enabled: false,
            },
            zoom: {
                enabled: true,
                duration: 300, // NB: also change the duration in CSS!
                opener: function (element) {
                    return element.find('img');
                }
            }
        });
    },

    /**
     * Search/filter classified ads by category.
     */
    searchForm: function() {
        var self = this;

        $('#results-searchform').on('submit', function(e) {
            e.preventDefault();

            if (self.lockAjaxGetResults) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxGetResults = true;

            // Display the loading spinner
            $('aside#sidebar .items').html('');
            $('aside#sidebar .loading').fadeIn();
            $('aside#sidebar .inner').mCustomScrollbar('update');
            $('aside#sidebar .inner').mCustomScrollbar('scrollTo', 'top');

            var startTime = new Date().getTime();

            self.ajaxGetResults(function(response) {
                if (response.success) {
                    var fakeLoadingTime = 0;
                    var requestTime = new Date().getTime() - startTime;

                    if (requestTime < 1000) {
                        fakeLoadingTime = 1000 - requestTime;
                    }

                    var replaceItems = function(response) {
                        // Hide the loading spinner
                        $('aside#sidebar .loading').fadeOut();

                        if (response.data.onlyForLoggedUser) {
                            $('aside#sidebar .items').html('<span class="onlyForLoggedUser">' + comedien.i18n.classifiedsOnlyForLoggedUser + '</span>');
                            $('aside#sidebar .inner').mCustomScrollbar("update");
                            $('aside#sidebar .results-top .title').html('<span>' + comedien.i18n.classifiedsTitleCountZero + '</span>' + ' ' + comedien.i18n.classifiedsTitleCountAnnonce);
                        } else {
                            // Display the classified ads in the results list
                            $('aside#sidebar .items').html(response.data.classifieds);
                            $('aside#sidebar .inner').mCustomScrollbar("update");

                            // Update the total number of posts
                            var total = parseInt(response.data.nbTotalClassifieds);
                            if (total == 0) {
                                $('aside#sidebar .results-top .title').html('<span>' + comedien.i18n.classifiedsTitleCountZero + '</span>' + ' ' + comedien.i18n.classifiedsTitleCountAnnonce);
                            } else if (total == 1) {
                                $('aside#sidebar .results-top .title').html('<span>' + total + '</span>' + ' ' + comedien.i18n.classifiedsTitleCountAnnonce);
                            } else {
                                $('aside#sidebar .results-top .title').html('<span>' + total + '</span>' + ' ' + comedien.i18n.classifiedsTitleCountAnnonce + 's');
                            }
                        }
                    };

                    if (fakeLoadingTime > 0) {
                        setTimeout(replaceItems(response), fakeLoadingTime);
                    } else {
                        replaceItems(response);
                    }

                    // Remember the search criteria for 1 day through cookies

                    helper.setCookie('classified_searchform_category', parseInt($('#results-searchform #category').val()), 1);
                } else {
                   M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                }

                self.lockAjaxGetResults = false;
            }, function(jqXHR, textStatus) {
                self.lockAjaxGetResults = false;
                M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            }, 0);
        });
    },

    populateSearchFormFromCookies: function() {
        var category = helper.getCookie('classified_searchform_category');

        var triggerSearch = false;

        if (category > 0) {
            $('#results-searchform #category').val(category);
            $('#results-searchform #category').formSelect('destroy');
            $('#results-searchform #category').formSelect();
            $('#results-searchform #category').trigger('change');
            triggerSearch = true;
        }

        if (triggerSearch) {
            // Trigger the search button to update the results
            $('#results-searchform').submit();
        }
    },

    reinitializeSearch: function() {
        $('.btn-reinit').on('click', function(e) {
            e.preventDefault();

            // Clear the search criteria

            $('#results-searchform #category').val('');
            $('#results-searchform #category').formSelect('destroy');
            $('#results-searchform #category').formSelect();

            // Clear the cookies

            console.log('delete cookie');
            helper.deleteCookie('classified_searchform_category');

            // Trigger the search button to update the results
            //$('#results-searchform').submit();

            // Reload the current page
            var url = $('#results-searchform').data('archive-url');
            window.location.replace(url);
        });
    },

    /**
     * Select a post from the sidebar (results list).
     */
    selectPostFromSidebar: function() {
        var self = this;

        $('aside#sidebar .items').on('click', '.item', function() {
            var idSelected = parseInt($(this).data('id'));
            var idCurrent = self.getIdCurrentViewed();

            if (idSelected > 0 && idSelected != idCurrent) {
                self.fetchAndReplacePost(idSelected);
            } else {
                $('aside#sidebar .button-expand').trigger('click');
            }
        });

        // HTM5 history - Handle the back button

        window.addEventListener('popstate', function(event) {
            var id = self.pagedOnLoad;

            if (event.state != null && event.state.classifieds) {
                id = event.state.id;
            }

            self.fetchAndReplacePost(id);
        });
    },

    /**
     * Fetch a post from its ID and replace the right pane content with the post HTML content.
     *
     * @param id
     */
    fetchAndReplacePost: function(idSelected) {
        var self = this;

        $('article#single').fadeTo(500 , 0.3, function() {
            if (self.lockAjaxGetPost) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxGetPost = true;

            M.toast({html: '<span>'+comedien.i18n.loading+'</span>'}, null, 'toastLoading');
            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'classifieds.get_post',
                    security: comedien.security,
                    id: idSelected,
                }
            }).done(function(response) {
                if (response.success && response.data.article.length > 0) {
                    // Replace the content
                    $('article#single').css('opacity', 0).replaceWith(response.data.article).fadeTo(500, 1, function() {
                        self.uiHoverCurrentViewed();
                        self.imagesSlider();
                        self.imageMagnificPopup();
                        layout.computeUiTitlesSeparator();
                        $('.toastLoading').fadeOut(500, function() {
                            $('.toastLoading').remove();
                        });
                    });

                    // Change the URL with HTML5 history

                    var newUrl = classifieds.archive + response.data.slugCategory + '/' + response.data.slugPost + '/';
                    var stateObj = { classifieds: true, id: idSelected };
                    history.pushState(stateObj, response.data.pageTitle, newUrl);
                    document.title = response.data.pageTitle;

                    // On mobile / tablet, hide the sidebar and display the right content area
                    $('aside#sidebar .button-expand').trigger('click');
                } else {
                    $('.toastLoading').remove();
                }

                self.uiColumnsMinHeight();

                self.lockAjaxGetPost = false;
            }).fail(function(jqXHR, textStatus) {
                self.uiColumnsMinHeight();

                self.lockAjaxGetPost = false;
                $('.toastLoading').remove();
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            });
        });
    },

    loadMorePosts: function(el) {
        var self = this;
        var nbDisplayed = this.getNumberDisplayedPosts();
        var nbTotal = classifieds.nbTotalClassifieds;

        if (nbDisplayed < nbTotal) {
            if (this.lockAjaxGetResults) {
                // Pending AJAX request... do nothing
                return;
            }

            this.lockAjaxGetResults = true;

            // Display the loading spinner
            $('aside#sidebar .loading').fadeIn();
            $('aside#sidebar .inner').mCustomScrollbar('update');
            $('aside#sidebar .inner').mCustomScrollbar('scrollTo', 'bottom');

            var startTime = new Date().getTime();

            // Fetch the posts
            self.ajaxGetResults(function(response) {
                if (response.success) {
                    var fakeLoadingTime = 0;
                    var requestTime = new Date().getTime() - startTime;

                    if (requestTime < 1000) {
                        fakeLoadingTime = 1000 - requestTime;
                    }

                    var appendItems = function(response) {
                        // Hide the loading spinner
                        $('aside#sidebar .loading').fadeOut();

                        // Display the classified ads in the results list
                        $('aside#sidebar .items').append(response.data.classifieds);
                        $('aside#sidebar .inner').mCustomScrollbar("update");
                    };

                    if (fakeLoadingTime > 0) {
                        setTimeout(appendItems(response), fakeLoadingTime);
                    } else {
                        appendItems(response);
                    }
                } else {
                   M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                }

                self.lockAjaxGetResults = false;
            }, function(jqXHR, textStatus) {
                self.lockAjaxGetResults = false;
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            }, nbDisplayed);
        }
    },

    getNumberDisplayedPosts: function() {
        return $('aside#sidebar .items .item').length;
    },

    /**
     * Fetch posts.
     *
     * @param {function} callbackDone   Function executed when the AJAX request is resolved
     * @param {function} callbackFail   Function executed when the AJAX request is rejected
     * @param {number}   offset         Exclude first 'n' records
     */
    ajaxGetResults: function(callbackDone, callbackFail, offset) {
        var category = parseInt($('#results-searchform #category').val());
        if (isNaN(category)) {
            category = 'all';
        }

        $.ajax({
            url: comedien.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'classifieds.get_results',
                security: comedien.security,
                nbDisplayedClassifieds: offset,
                category: category,
            }
        }).done(callbackDone).fail(callbackFail);
    },
};

module.exports = new FrontClassifieds();
